import type { PropertyValue } from './Common';

export interface User {
  id?: string;
  userId?: string;
  deviceId?: string;
  identifiers?: {
    [key: string]: string;
  };
  properties?: {
    [key: string]: PropertyValue;
  };
}
